import React, { useEffect, useState } from "react";
import { Card } from "../shared";
import { teamApi } from "../../lib/api";
import { Avatar } from "./TeamChips";

export const ago = (iso) => {
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};

export const ActivityFeed = ({ dealKey, dealName, refreshKey }) => {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    teamApi.activity({ dealKey, dealName, limit: 60 }).then(setRows).catch(() => setRows([]));
  }, [dealKey, dealName, refreshKey]);
  return (
    <Card title="Team activity — who did what" testid="team-activity">
      {rows.length === 0 && <div className="cm-empty">No activity yet. Lead edits, emails, timeline changes and assignments show up here.</div>}
      <div className="tm-feed">
        {rows.map((r) => (
          <div key={r.id} className="tm-feed-row" data-testid={`activity-${r.id}`}>
            <Avatar name={r.byName} email={r.by} size={22} />
            <span className="tm-feed-txt"><b>{r.byName}</b> {r.action}{r.target ? <> <em>{r.target}</em></> : null}</span>
            <span className="tm-feed-when">{ago(r.at)}</span>
          </div>
        ))}
      </div>
    </Card>
  );
};
